export default __webpack_public_path__ + "static/1_37-608bef3ab83e64bc3091304fe56397c5.png";